/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-01-08 19:24:26
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsySelectCheckBox from '../../BsySelectCheckBox';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import BsySelect from '../../BsySelect';
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterFlowDecision extends BsyFilterBase {



    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            items: [{
                text: React.language("filter.method.ep"),
                value: 0
            }, {
                text: React.language("approved"),
                value: 1
            }, {
                text: React.language("approval.rejected"),
                value: 2
            }],
            ...props
        })

        this.dashText = null;
    }


    componentDidMount() {
        super.componentDidMount()

    }


    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN, BsyConfig().CONST.FILTER_METHOD.EQ, BsyConfig().CONST.FILTER_METHOD.NE, BsyConfig().CONST.FILTER_METHOD.EP]
    }


    getValue = () => {
        let e = this.dashText.getValue();
        switch (this.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:
            case BsyConfig().CONST.FILTER_METHOD.LK:
            case BsyConfig().CONST.FILTER_METHOD.ULK:
                return {
                    value: e
                };
            case BsyConfig().CONST.FILTER_METHOD.IN:
            case BsyConfig().CONST.FILTER_METHOD.NIN:

                if (BsyUtils.isObjectEmpty(e))
                    return { items: [], hasEmpty: false };
                let e1 = [].concat(e)
                    , t = !1
                    , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                if (i > -1) {
                    t = !0
                    e1.splice(i, 1)
                }
                return {
                    hasEmpty: t,
                    items: e1
                }
            // return e;
            default:
                return null
        }

        // return {
        //     value: this.dashText.getValue()
        // }
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE: {
                return <BsySelect
                    theme={this.props.theme}
                    hasLimit={!0}
                    allowBlank={true}
                    height={'34px'}
                    items={[{
                        value: 0,
                        text: React.language("filter.method.ep")
                    },
                    {
                        value: 1,
                        text: React.language("approved")
                    },
                    {
                        value: 2,
                        text: React.language("approval.rejected")
                    }
                    ]}
                    value={val ? BsyUtils.isArray(val.value) ? val.value[0] : val.value : null}
                    onStopEdit={e1 => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(e, i.onStopEdit, [{
                            value: e.getValue(),
                            valueMode: e.valueMode,
                            method: e.method,
                        }, i], !1)
                    }}
                    getContext={this.getContext}
                />
            }
            case BsyConfig().CONST.FILTER_METHOD.IN: {
                return <BsySelectCheckBox
                    theme={this.props.theme}
                    allowBlank={false}
                    // hasDefault={!0}
                    value={val ? val.value : null}
                    hasSelectAll={true}
                    hasSelectEmpty={true}
                    height={'34px'}
                    items={[{
                        value: 0,
                        text: React.language("filter.method.ep")
                    },
                    {
                        value: 1,
                        text: React.language("approved")
                    },
                    {
                        value: 2,
                        text: React.language("approval.rejected")
                    }
                    ]}
                    onStopEdit={e1 => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(e, i.onStopEdit, [{
                            value: e.getValue(),
                            valueMode: e.valueMode,
                            method: e.method,
                        }, i], !1)
                    }}
                    getContext={this.getContext}

                />

            }
            default:
        }



    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

